module.exports = __webpack_public_path__ + "static/media/estacao-movel.276e4fd7.png";